import React, { Component } from "react";
import { LicenseRenewalContainerContext } from "src/components/LicenseRenewalContainerContext";
import { LicenseRenewalSubscriptionContext } from "./LicenseRenewalSubscriptionContext";
import LicenseRenewalSuccess from "./components/LicenseRenewalSuccess";
import PaymentConfirmation from "./components/PaymentConfirmation";
import { FlexContainer } from "src/components";
import LicenseActivation from "./LicenseActivation";
import { ClientLicenseStatus, FormStep } from "./components/Constants";
import { getAppDetails } from "src/config/appVariants";

class LicenseRenewal extends Component {
    static contextType = LicenseRenewalContainerContext;

    state = {
        purchaseStep: FormStep.PAGE_PURCHASE_LICENSE,
        purchaseLicenseLoading: false,
        licenseCount: 1,
    };

    nextStep = (stepNumber) => {
        this.setState({ 
            purchaseStep: stepNumber
        });
    };

    render() {
        const { 
            licenseTermDuration, 
            licenseTermDurationUnit, 
            licenseTermAmount, 
            isAustralian, 
            gstAmount, 
            currency,
            chargeAmount, 
            accessToken, 
            key, 
            referralCode,
            employeeName, 
            businessName, 
            licenseStatus, 
            finishDate, 
            processingFee, 
            basePrice,
            appVariant
        } = this.context;
        const app = getAppDetails(appVariant);
        const appDisplayName = `${app.brandName} app`;
        const durationNiceString = licenseTermDuration + " " + licenseTermDurationUnit.charAt(0).toUpperCase() + licenseTermDurationUnit.slice(1);
        
        if (this.state.purchaseStep === FormStep.PAGE_PURCHASE_SUCCESSFUL)
            return <LicenseRenewalSuccess durationNiceString={durationNiceString}/>;

        if (this.state.purchaseStep === FormStep.PAGE_PAYMENT_CONFIRMATION) {
            return (
                <FlexContainer style={{ margin: "auto 0" }}>
                    <LicenseRenewalSubscriptionContext.Provider value={{
                        //global
                        nextStep: this.nextStep,
                        referralCode: referralCode,
                        key: key,
                        companyName: businessName,
                        licenseTermDuration: licenseTermDuration,
                        licenseTermAmount: licenseTermAmount,
                        licenseTermDurationUnit: licenseTermDurationUnit,
                        isAustralian: isAustralian,
                        gstAmount: gstAmount,
                        currency: currency,
                        chargeAmount: chargeAmount,
                        processingFee: processingFee,
                        basePrice: basePrice,
                    }}>
                        <PaymentConfirmation />
                    </LicenseRenewalSubscriptionContext.Provider>
                </FlexContainer>
            );
        }

        const renewalDescription = licenseStatus !== "active"
            ? `your trial license for ${businessName} - ${appDisplayName} has reached its expiration date.`
            : `your license for ${businessName} - ${appDisplayName} is due to expire on ${finishDate}.`;

        return (
            <FlexContainer style={{ margin: "auto 0" }}>
                {licenseStatus === ClientLicenseStatus.INITIAL_PAYMENT_REQUIRED ? (
                    <LicenseActivation
                        employeeName={employeeName}
                        durationNiceString={durationNiceString}
                        currency={currency}
                        accessToken={accessToken}
                        onNext={() => this.nextStep(FormStep.PAGE_PAYMENT_CONFIRMATION)}
                        basePrice={basePrice}
                    />
                ) : <LicenseActivation
                    employeeName={employeeName}
                    durationNiceString={durationNiceString}
                    currency={currency}
                    accessToken={accessToken}
                    onNext={() => this.nextStep(FormStep.PAGE_PAYMENT_CONFIRMATION)}
                    basePrice={basePrice}
                    title="Renew License"
                    description={`Dear ${employeeName}, ${renewalDescription}`}
                    subscriptionTitle="Renew your subscription"
                    subscriptionDescription={`Purchase a ${durationNiceString} license to ensure uninterrupted access to your ${businessName} - ${appDisplayName}.`}
                    actionLabel="Renew License"
                    alignActionRight
                />}
            </FlexContainer>
        );
    }
}

export default LicenseRenewal;
